/* EnterView  */
const reveals = document.querySelectorAll('.reveal');
const wiggles = document.querySelectorAll('.wiggle');

if (reveals.length > 0) {
  enterView({
    selector: '.reveal',
    enter: (el, i) => {
      el.classList.add('entered');
    },
    exit: el => {
      el.classList.remove('entered');
    },
    offset: 0.1
  });
}

if (wiggles.length > 0) {
  enterView({
    selector: '.wiggle',
    enter: (el, i) => {
      el.classList.add('animate');
    },
    exit: el => {
      el.classList.remove('animate');
    },
    offset: 0.1
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const paths = document.querySelectorAll(
    '.arrow-draw .animate-draw'
  );
  const dottedLines = document.querySelectorAll(
    '.dotted-line-svg .dotted-line'
  );

  dottedLines.forEach(path => {
    const length = path.getTotalLength();
    path.style.strokeDasharray = length;
    path.style.strokeDashoffset = length;
  });

  if (document.querySelectorAll('.dotted-line-svg').length > 0) {
    enterView({
      selector: '.dotted-line-svg',
      enter: el => el.classList.add('animate-line'),
      exit: el => el.classList.remove('animate-line'),
      offset: 0.2
    });
  }

  paths.forEach(path => {
    const length = path.getTotalLength();
    path.style.strokeDasharray = length;
    path.style.strokeDashoffset = length;
  });

  if (document.querySelectorAll('.arrow-draw').length > 0) {
    enterView({
      selector: '.arrow-draw',
      enter: el => {
        // force reflow
        void el.offsetWidth;
        el.classList.add('animate');
      },
      exit: el => el.classList.remove('animate'),
      offset: 0.1
    });
  }
});

/* Swiper Initialiser */
const productCarousels = document.querySelectorAll(
  '.product__carousel-wrapper'
);

productCarousels.forEach(wrapper => {
  const mainEl = wrapper.querySelector('.carousel_product');
  const thumbsEl = wrapper.querySelector('.carousel_product_thumbs');

  let thumbsSwiper = null;
  if (thumbsEl) {
    thumbsSwiper = new Swiper(thumbsEl, {
      slidesPerView: 3,
      spaceBetween: 12,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      breakpoints: {
        0: { slidesPerView: 3 },
        768: { slidesPerView: 3 }
      }
    });
  }

  const mainSwiperOptions = {
    slidesPerView: 1,
    speed: 300,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-product-button-next',
      prevEl: '.swiper-product-button-prev'
    }
  };
  if (thumbsSwiper) {
    mainSwiperOptions.thumbs = { swiper: thumbsSwiper };
  }

  const mainSwiper = new Swiper(mainEl, mainSwiperOptions);
});

var swiperTestimonialsCarousel = new Swiper(
  '.swiper-testimonials-carousel',
  {
    direction: 'horizontal',
    slidesPerView: 1,
    loop: true,
    spaceBetween: 14,
    centeredSlides: true,
    speed: 3000,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    navigation: {
      nextEl: '.swiper-testimonials-carousel-button-next',
      prevEl: '.swiper-testimonials-carousel-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 1.5,
        spaceBetween: 50
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 65
      }
    }
  }
);

var swiperFeaturedCollection = new Swiper(
  '#featuredCollectionSlider',
  {
    direction: 'horizontal',
    slidesPerView: 1.2,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-featured-collection-button-next',
      prevEl: '.swiper-featured-collection-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 3.4,
        spaceBetween: 28,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16
      },
      1024: {
        slidesPerView: 4.6,
        spaceBetween: 28,
        slidesOffsetBefore: 120,
        slidesOffsetAfter: 120
      }
    }
  }
);

var tabbedContentSlider = new Swiper('#tabbedContentSlider', {
  direction: 'horizontal',
  slidesPerView: 1.2,
  spaceBetween: 16,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  navigation: {
    nextEl: '.swiper-tabbed-content-button-next',
    prevEl: '.swiper-tabbed-content-button-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 3.8,
      spaceBetween: 16,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0
    },
    1024: {
      slidesPerView: 4.8,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16
    }
  }
});

var navigationCollectionSlider = new Swiper(
  '#navigationCollectionSlider',
  {
    direction: 'horizontal',
    slidesPerView: 2.5,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    spaceBetween: 20
  }
);

var swiperMultiColumn = new Swiper('#multiColumnSlider', {
  direction: 'horizontal',
  slidesPerView: 1,
  spaceBetween: 16,
  navigation: {
    nextEl: '.swiper-multicolumn-button-next',
    prevEl: '.swiper-multicolumn-button-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2.5,
      spaceBetween: 40
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 40,
      slidesOffsetBefore: 0
    }
  }
});

var swiperMultiColumnText = new Swiper('#multiColumnTextSlider', {
  direction: 'horizontal',
  slidesPerView: 1.2,
  slidesOffsetBefore: 20,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-mulitcolumn-button-next',
    prevEl: '.swiper-mulitcolumn-button-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2.5,
      spaceBetween: 40,
      slidesOffsetBefore: 40
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 0,
      slidesOffsetBefore: 0
    }
  }
});

var tabContentSwiper = new Swiper('.tab-content__swiper', {
  direction: 'horizontal',
  slidesPerView: 1,
  centeredSlides: false,
  loop: false,
  spaceBetween: 40,
  navigation: {
    nextEl: '.swiper-tab-content-button-next',
    prevEl: '.swiper-tab-content-button-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2
    }
  }
});

var swiperInstagramCarousel = new Swiper(
  '.swiper-instagram-carousel',
  {
    direction: 'horizontal',
    slidesPerView: 1.8,
    spaceBetween: 23,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    navigation: {
      nextEl: '.swiper-instagram-carousel-button-next',
      prevEl: '.swiper-instagram-carousel-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 4.8,
        spaceBetween: 23,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16
      },
      1024: {
        slidesPerView: 5.8,
        spaceBetween: 23,
        slidesOffsetBefore: 120,
        slidesOffsetAfter: 120
      }
    }
  }
);

// Cart ATC FUNCTIONALITY
const optionSelect = document.querySelector(
  '.pcard--cart [data-purchase-type-select]'
);
const subscriptionSelect = document.querySelector(
  '.pcard--cart [data-subsciption-select]'
);
const variantSelect = document.querySelector(
  '.pcard--cart [data-variant-select'
);
const sellingPlanInput = document.querySelector(
  '.pcard--cart #sellingPlanSelect'
);

const regPrice = document.querySelector(
  '.pcard--cart .product-card__normal-price'
);
const subPrice = document.querySelector(
  '.pcard--cart .product-card__sub-price'
);

const selects = document.querySelectorAll(
  '.pcard--cart .product-card__option-select-container'
);

if (optionSelect) {
  optionSelect.addEventListener('change', e => {
    const value = e.target.value;

    if (value == 'oneOff') {
      subscriptionSelect.style.display = 'none';
      subPrice.style.display = 'none';
      sellingPlanInput.name = '';
      regPrice.classList.add('product-card__normal-price--regular');
    } else if (value == 'subscription') {
      subscriptionSelect.style.display = 'flex';
      subPrice.style.display = 'block';
      sellingPlanInput.name = 'selling_plan';
      regPrice.classList.remove(
        'product-card__normal-price--regular'
      );
    }
  });
}

if (variantSelect) {
  variantSelect.addEventListener('change', e => {
    const el = e.target.options[e.target.selectedIndex];
    const elPrice = el.dataset.price;
    const elSubPrice = el.dataset.subPrice;

    regPrice.innerHTML = formatMoney(regPrice.innerHTML, elPrice);
    regPrice.dataset.price = elPrice;

    if (elSubPrice) {
      subPrice.innerHTML = formatMoney(
        regPrice.innerHTML,
        elSubPrice
      );
      subPrice.dataset.price = elSubPrice;
    }
  });
}

// Product Card ATC Forms Open / Close
let productCardAtc = document.querySelectorAll('[data-card-atc]');

function listenersToCards() {
  productCardAtc.forEach(atc => {
    const card = atc.closest('.pcard');
    const form = card.querySelector('.product-card__atc-form');
    const closeBtn = card.querySelector(
      '.product-card__atc-form-close-btn'
    );
    const quantity = card.querySelector('.product-card__quantity');
    const btns = card.querySelectorAll('.product-card__quantity-btn');
    const optionSelect = card.querySelector(
      '[data-purchase-type-select]'
    );
    const optionContainer = optionSelect?.closest(
      '.product-card__option-select-container'
    );
    const subscriptionSelect = card.querySelector(
      '[data-subsciption-select]'
    );
    const variantSelect = card.querySelector('[data-variant-select]');
    const sellingPlanInput = card.querySelector('#sellingPlanSelect');
    const regPrice = card.querySelector(
      '.product-card__normal-price, .product-card__regular-price'
    );
    const subPrice = card.querySelector('.product-card__sub-price');
    const selects = form.querySelectorAll(
      '.product-card__option-select-container'
    );
    const currency = regPrice?.dataset?.currency || '£';

    function toggleSubUI(hasSub) {
      // If this card has no subscription UI, exit safely
      if (!optionSelect) return;

      if (optionContainer) {
        optionContainer.style.display = hasSub ? 'flex' : 'none';
      }

      if (hasSub) {
        const wantsSub = optionSelect.value === 'subscription';

        if (subscriptionSelect)
          subscriptionSelect.style.display = wantsSub
            ? 'flex'
            : 'none';

        if (subPrice)
          subPrice.style.display = wantsSub ? 'block' : 'none';

        if (sellingPlanInput)
          sellingPlanInput.name = wantsSub ? 'selling_plan' : '';

        regPrice?.classList.toggle(
          'product-card__normal-price--regular',
          !wantsSub
        );
      } else {
        optionSelect.value = 'oneOff';

        if (subscriptionSelect)
          subscriptionSelect.style.display = 'none';

        if (subPrice) subPrice.style.display = 'none';

        if (sellingPlanInput) sellingPlanInput.name = '';

        regPrice?.classList.add(
          'product-card__normal-price--regular'
        );
      }
    }

    atc.addEventListener('click', e => {
      e.preventDefault();
      form.classList.add('active');
      selects.forEach(sel =>
        sel.addEventListener('click', e => e.preventDefault())
      );
    });

    btns.forEach(btn =>
      btn.addEventListener('click', e => {
        e.preventDefault();
        changeCardQuantity(card, btn.name);
      })
    );

    closeBtn.addEventListener('click', e => {
      e.preventDefault();
      form.classList.remove('active');
    });

    quantity.addEventListener('click', e => e.preventDefault());

    let lastHasSub = false;

    if (variantSelect) {
      const initOpt =
        variantSelect.options[variantSelect.selectedIndex];
      lastHasSub = initOpt?.dataset?.hasSub === 'true';

      if (optionSelect) {
        optionSelect.value = 'oneOff';
      }

      toggleSubUI(lastHasSub);
    }

    optionSelect?.addEventListener('change', () => {
      toggleSubUI(lastHasSub);
    });

    variantSelect?.addEventListener('change', e => {
      const el = e.target.options[e.target.selectedIndex];
      const hasSub = el.dataset.hasSub === 'true';
      const price = el.dataset.price;
      const subPriceV = el.dataset.subPrice;
      const qty = quantity.querySelector('input').value;

      regPrice.innerHTML =
        currency + ((price / 100) * qty).toFixed(2);
      regPrice.dataset.price = price;

      if (subPriceV) {
        subPrice.innerHTML =
          currency + ((subPriceV / 100) * qty).toFixed(2);
        subPrice.dataset.price = subPriceV;
      }

      lastHasSub = hasSub;
      toggleSubUI(hasSub);
    });
  });
}

listenersToCards();

window.addEventListener('load', () => {
  setTimeout(() => {
    document
      .querySelectorAll('[data-variant-select]')
      .forEach(select => {
        select.dispatchEvent(new Event('change'));
      });
  }, 200);
});

// NAVIGATION MOBILE
document.addEventListener('click', e => {
  const toggle = e.target.closest('[data-toggle-submenu]');
  if (!toggle) return;

  const submenu = document.getElementById(
    toggle.getAttribute('aria-controls')
  );
  const expanded = toggle.getAttribute('aria-expanded') === 'true';

  toggle.setAttribute('aria-expanded', String(!expanded));

  if (!expanded) {
    // OPEN
    submenu.style.height = submenu.scrollHeight + 'px';

    submenu.addEventListener(
      'transitionend',
      () => {
        submenu.style.height = 'auto';
      },
      { once: true }
    );
  } else {
    // CLOSE
    submenu.style.height = submenu.scrollHeight + 'px';
    requestAnimationFrame(() => {
      submenu.style.height = '0px';
    });
  }
});
// // END OF NAVIGATION MOBILE

// NAVIGATION
const navigation = document.querySelector('#navigation');
const headerWrapper = document.querySelector('header');
const menuItems = Array.from(
  document.querySelectorAll('#headerMenuItem')
);
const childLinks = document.querySelectorAll(
  '.navigation__child-link'
);

const collectionLinks = document.querySelectorAll(
  '.js-collection-link[data-collection]'
);
const collectionProductGroups = document.querySelectorAll(
  '.navigation__collection-products'
);
const shopLayout = document.querySelector('.navigation__shop-layout');

/* -----------------------------
  Accessibility: initial ARIA
------------------------------ */
menuItems.forEach(item => {
  if (item.classList.contains('has-children')) {
    item.setAttribute('aria-haspopup', 'true');
    item.setAttribute('aria-expanded', 'false');
  }
});

/* -----------------------------
  Helpers
------------------------------ */
function closeNavigation() {
  navigation.classList.remove('active');
  headerWrapper.classList.remove('nav-active');

  menuItems.forEach(item => {
    item.classList.remove('active');
    item.setAttribute('aria-expanded', 'false');
  });

  childLinks.forEach(child => child.classList.remove('active'));
}

function resetCollections() {
  const activeMenu = document.querySelector('#navChildMenu.active');
  if (!activeMenu) return;

  const firstCollectionLink = activeMenu.querySelector(
    '.js-collection-link[data-collection]'
  );
  if (!firstCollectionLink) return;

  const handle = firstCollectionLink.dataset.collection;

  collectionLinks.forEach(l => l.classList.remove('active'));
  collectionProductGroups.forEach(group =>
    group.classList.remove('active')
  );

  firstCollectionLink.classList.add('active');

  const firstGroup = activeMenu.querySelector(
    `.navigation__collection-products[data-collection="${handle}"]`
  );

  if (firstGroup) {
    firstGroup.classList.add('active');
  }
}

/* -----------------------------
  Top-level menu (CLICK)
------------------------------ */
menuItems.forEach(item => {
  item.addEventListener('click', e => {
    const navItem = item.dataset.navItem;
    const hasChildren = item.classList.contains('has-children');
    const isAlreadyActive = item.classList.contains('active');

    if (hasChildren) {
      e.preventDefault();
    }

    closeNavigation();

    // Toggle off if already open
    if (isAlreadyActive || !hasChildren) return;

    const childLink = document.querySelector(
      `#navChildMenu[data-nav-item="${navItem}"]`
    );
    if (!childLink) return;

    // Open
    childLink.classList.add('active');
    item.classList.add('active');
    item.setAttribute('aria-expanded', 'true');

    navigation.classList.add('active');
    headerWrapper.classList.add('nav-active');

    resetCollections();
  });
});

/* -----------------------------
  Click outside → close
------------------------------ */
document.addEventListener('click', e => {
  const clickedInside =
    navigation.contains(e.target) ||
    e.target.closest('#headerMenuItem');

  if (!clickedInside) {
    closeNavigation();
  }
});

/* -----------------------------
  Escape key → close
------------------------------ */
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    closeNavigation();
  }
});

/* -----------------------------
  Collection hover (Shop)
------------------------------ */
collectionLinks.forEach(link => {
  link.addEventListener('mouseenter', () => {
    const handle = link.dataset.collection;
    if (!handle) return;

    collectionLinks.forEach(l => l.classList.remove('active'));
    collectionProductGroups.forEach(group =>
      group.classList.remove('active')
    );

    link.classList.add('active');

    const activeGroup = document.querySelector(
      `.navigation__collection-products[data-collection="${handle}"]`
    );

    if (activeGroup) {
      activeGroup.classList.add('active');
    }
  });
});

/* -----------------------------
  Leaving Shop → reset top item
------------------------------ */
if (shopLayout) {
  shopLayout.addEventListener('mouseleave', () => {
    resetCollections();
  });
}
// END OF NAVIGATION

// MOBILE VIEWPORT HEIGHT FIX
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/* Toggle Class (Generic) */
function toggleClass(modalName, className = 'active') {
  var modalActive = document.querySelector(modalName);
  modalActive.classList.toggle(className);
}

function toggleMultipleClass(
  selector1,
  selector2,
  className = 'active'
) {
  const el1 = document.querySelector(selector1);
  const el2 = document.querySelector(selector2);

  if (el1) el1.classList.toggle(className);
  if (el2) el2.classList.toggle(className);
}

/* Toggle forgot password form */
const forgotPasswordButtons = document.querySelectorAll(
  '.login__forgot-password-button'
);

forgotPasswordButtons.forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    toggleClass('.login__form');
    toggleClass('.forgot-password-form');

    console.log('here', button);
  });
});

/* Change Product Quantity */
function changeQuantity(formId, quantity) {
  var formQ = document.querySelector(formId);

  if (quantity == '+') {
    Number(formQ.value++);
  } else if (quantity == '-' && formQ.value > 1) {
    Number(formQ.value--);
  }
}

/* Open Cart */
function cartOpen() {
  document.querySelector('body').classList.add('js-my-cart-open');
}

/* Details Animator (not cart accordions: it would close them on clicks inside the form fields) */
const details = document.querySelectorAll('details:not([data-cart-accordion])');

if (details) {
  details.forEach(targetDetail => {
    targetDetail.addEventListener('click', function (e) {
      if (targetDetail.hasAttribute('open')) {
        e.preventDefault();
        targetDetail.classList.add('closing');
        setTimeout(() => {
          targetDetail.removeAttribute('open');
          targetDetail.classList.remove('closing');
        }, 390);
      }
    });
  });
}

/* Orphan Remove and LSEP Removal */
var nbspSelectors = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'a',
  'span'
];
var nbspWordMin = 10; //Minimum words within parent tag to activate script

nbspSelectors.forEach(function (selector) {
  var nbspElements = document.querySelectorAll(selector);
  nbspElements.forEach(function (element) {
    element.innerHTML = element.innerHTML.replace(/\u2028/g, '');
    element.innerHTML = element.innerHTML.replace(/&#8232;/g, '');
    var wordCount = element.innerHTML.split(' ').length;
    if (wordCount >= nbspWordMin) {
      element.innerHTML = element.innerHTML.replace(
        / ([^ ]*)$/,
        '&nbsp;$1'
      );
    }
  });
});

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({});

/* Liquid Ajax Cart */
liquidAjaxCart.subscribeToCartAjaxRequests(
  (state, subscribeToResult) => {
    if (state.requestType == 'add') {
      const form = state.info?.initiator;
      if (!(form instanceof Element)) return;
      let btnInner = '';

      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btnInner = btn.innerHTML;
        btn.innerHTML = 'ADDING';
      }

      subscribeToResult(state => {
        const btn = form.querySelector('button[type="submit"]');
        // Don't open the drawer when the add-on is added from the cart page
        if (state.responseData.ok && !form.closest('.cart-addon--page')) {
          cartOpen();
        }

        if (btn) {
          setTimeout(() => {
            btn.innerHTML = btnInner;
          }, 300);
        }
      });
    }
  }
);

/* Free Sample Auto-Add/Remove */
(function () {
  var SAMPLE_HANDLE = 'london-nootropics-free-sample';
  var sampleVariantId = null;
  var syncing = false;
  var dismissed = sessionStorage.getItem('sampleDismissed') === '1';

  // Track when customer manually removes the sample
  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-remove-free-sample')) {
      dismissed = true;
      sessionStorage.setItem('sampleDismissed', '1');
    }
  });

  function syncSample() {
    if (!sampleVariantId || syncing) return;

    var state = liquidAjaxCart.getCartState();
    if (!state.status.cartStateSet) return;

    var cart = state.cart;
    var sampleItem = null;
    var hasNonSampleItems = false;

    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === SAMPLE_HANDLE) {
        sampleItem = cart.items[i];
      } else {
        hasNonSampleItems = true;
      }
    }

    if (!hasNonSampleItems) {
      // Reset dismissed flag when cart is emptied
      dismissed = false;
      sessionStorage.removeItem('sampleDismissed');
    }

    if (hasNonSampleItems && !sampleItem && !dismissed) {
      syncing = true;
      liquidAjaxCart.cartRequestAdd(
        { items: [{ id: sampleVariantId, quantity: 1 }] },
        { lastComplete: function () { syncing = false; } }
      );
    } else if (!hasNonSampleItems && sampleItem) {
      syncing = true;
      liquidAjaxCart.cartRequestChange(
        { id: sampleItem.key, quantity: 0 },
        { lastComplete: function () { syncing = false; } }
      );
    } else if (sampleItem && sampleItem.quantity > 1) {
      syncing = true;
      liquidAjaxCart.cartRequestChange(
        { id: sampleItem.key, quantity: 1 },
        { lastComplete: function () { syncing = false; } }
      );
    }
  }

  liquidAjaxCart.subscribeToCartStateUpdate(function (state, isCartUpdated) {
    if (isCartUpdated && !syncing) {
      syncSample();
    }
  });

  fetch('/products/' + SAMPLE_HANDLE + '.js')
    .then(function (r) { return r.json(); })
    .then(function (product) {
      if (product.available && product.variants) {
        var variant = product.variants.find(function (v) { return v.available; });
        if (variant) {
          sampleVariantId = variant.id;
          syncSample();
        }
      }
    })
    .catch(function () {});
})();

/* Cart Add-on: remove below spend threshold, clamp quantity to 1 */
(function () {
  var ADDON_HANDLE = document.body.dataset.cartAddonHandle;
  var THRESHOLD = parseInt(document.body.dataset.cartAddonThreshold, 10) || 0;
  var syncing = false;

  if (!ADDON_HANDLE) return;

  function syncAddon() {
    if (syncing) return;

    var state = liquidAjaxCart.getCartState();
    if (!state.status.cartStateSet) return;

    var cart = state.cart;
    var addonItem = null;
    var addonTotal = 0;

    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === ADDON_HANDLE) {
        addonItem = cart.items[i];
        addonTotal += cart.items[i].final_line_price;
      }
    }

    if (!addonItem) return;

    var spend = cart.items_subtotal_price - addonTotal;

    if (spend < THRESHOLD || spend === 0) {
      syncing = true;
      liquidAjaxCart.cartRequestChange(
        { id: addonItem.key, quantity: 0 },
        { lastComplete: function () { syncing = false; } }
      );
    } else if (addonItem.quantity > 1) {
      syncing = true;
      liquidAjaxCart.cartRequestChange(
        { id: addonItem.key, quantity: 1 },
        { lastComplete: function () { syncing = false; } }
      );
    }
  }

  liquidAjaxCart.subscribeToCartStateUpdate(function (state, isCartUpdated) {
    if (isCartUpdated && !syncing) {
      syncAddon();
    }
  });

  syncAddon();
})();

/* Cart Discount Code */
(function () {
  var data = document.body.dataset;
  var AUTO_CODE = upper(data.discountAutoaddCode);
  var COMPANION_CODE = upper(data.discountAutoaddCompanion);
  var AUTO_HANDLE = data.discountAutoaddHandle;
  var AUTO_VARIANT = parseInt(data.discountAutoaddVariant, 10) || 0;

  var busy = false;
  var liveCodes = false;
  var errorMessage = '';

  function upper(value) {
    return String(value || '').trim().toUpperCase();
  }

  function getCart() {
    var state = liquidAjaxCart.getCartState();
    return state.status.cartStateSet ? state.cart : null;
  }

  // Liquid's initial state may not carry discount codes, so the rendered list is used until a request has returned them
  function cartCodes(includeInapplicable) {
    var cart = getCart();
    if (liveCodes && cart && Array.isArray(cart.discount_codes)) {
      return cart.discount_codes
        .filter(function (d) { return includeInapplicable || d.applicable !== false; })
        .map(function (d) { return upper(d.code); });
    }
    var box = document.querySelector('[data-cart-discount]');
    return box
      ? Array.prototype.map.call(box.querySelectorAll('[data-cart-discount-remove]'), function (btn) {
          return upper(btn.dataset.cartDiscountRemove);
        })
      : [];
  }

  function has(codes, code) {
    return codes.indexOf(code) !== -1;
  }

  function hasAutoProduct(cart) {
    return cart.items.some(function (item) { return item.handle === AUTO_HANDLE; });
  }

  // The companion code only ever travels with the auto-add code
  function normalise(codes) {
    var result = codes.filter(function (code) { return code && code !== COMPANION_CODE; });
    if (COMPANION_CODE && has(result, AUTO_CODE)) result.push(COMPANION_CODE);
    return result;
  }

  function request(method, body, done) {
    busy = true;
    liquidAjaxCart[method](body, {
      lastComplete: function () {
        busy = false;
        if (done) done();
      }
    });
  }

  function setCodes(codes, done) {
    request('cartRequestUpdate', { discount: normalise(codes).join(',') }, done);
  }

  function addAutoProduct(done) {
    request('cartRequestAdd', { items: [{ id: AUTO_VARIANT, quantity: 1 }] }, done);
  }

  function showError() {
    document.querySelectorAll('[data-cart-discount-error]').forEach(function (el) {
      el.textContent = errorMessage;
      el.hidden = !errorMessage;
    });
  }

  function apply(code) {
    code = upper(code);
    var cart = getCart();
    if (!code || busy || !cart) return;

    errorMessage = '';
    var codes = cartCodes(true);
    if (!has(codes, code)) codes.push(code);

    function finish() {
      if (has(cartCodes(false), code)) {
        showError();
        return;
      }
      errorMessage = 'Sorry, the code ' + code + " can't be applied to this order.";
      setCodes(cartCodes(true).filter(function (c) { return c !== code; }), showError);
    }

    if (code === AUTO_CODE && AUTO_VARIANT && !hasAutoProduct(cart)) {
      addAutoProduct(function () { setCodes(codes, finish); });
    } else {
      setCodes(codes, finish);
    }
  }

  function remove(code) {
    code = upper(code);
    if (busy || !getCart()) return;
    errorMessage = '';
    setCodes(cartCodes(true).filter(function (c) { return c !== code; }), showError);
  }

  // Keep the auto-add code and its product together
  function sync(isInitial) {
    if (!AUTO_CODE || !AUTO_HANDLE || busy) return;
    var cart = getCart();
    if (!cart) return;

    var codes = cartCodes(true);
    var hasCode = has(codes, AUTO_CODE);

    if (hasCode && !hasAutoProduct(cart)) {
      if (isInitial && AUTO_VARIANT) {
        addAutoProduct(function () { setCodes(codes); });
      } else {
        setCodes(codes.filter(function (c) { return c !== AUTO_CODE; }));
      }
    } else if (!hasCode && has(codes, COMPANION_CODE)) {
      setCodes(codes);
    }
  }

  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('[data-cart-discount-apply]');
    if (applyBtn) {
      apply(applyBtn.closest('[data-cart-discount]').querySelector('[data-cart-discount-input]').value);
      return;
    }
    var removeBtn = e.target.closest('[data-cart-discount-remove]');
    if (removeBtn) remove(removeBtn.dataset.cartDiscountRemove);
  });

  // Enter would otherwise submit the cart form
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-cart-discount-input]')) {
      e.preventDefault();
      apply(e.target.value);
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-cart-discount-input]') && errorMessage) {
      errorMessage = '';
      showError();
    }
  });

  liquidAjaxCart.subscribeToCartAjaxRequests(function (requestState, subscribeToResult) {
    subscribeToResult(function () { liveCodes = true; });
  });

  var initialised = false;
  liquidAjaxCart.subscribeToCartStateUpdate(function (state, isCartUpdated) {
    if (!state.status.cartStateSet) return;
    if (!initialised) {
      initialised = true;
      sync(true);
    } else if (isCartUpdated) {
      sync(false);
    }
  });

  liquidAjaxCart.subscribeToCartSectionsUpdate(showError);

  if (getCart() && !initialised) {
    initialised = true;
    sync(true);
  }
})();

/* Cart Accordions */
(function () {
  var openState = {};

  // "toggle" doesn't bubble
  document.addEventListener('toggle', function (e) {
    var el = e.target;
    if (el instanceof HTMLDetailsElement && el.dataset.cartAccordion) {
      openState[el.dataset.cartAccordion] = el.open;
    }
  }, true);

  liquidAjaxCart.subscribeToCartSectionsUpdate(function () {
    document.querySelectorAll('details[data-cart-accordion]').forEach(function (el) {
      var name = el.dataset.cartAccordion;
      if (name in openState) el.open = openState[name];
    });
  });
})();

/* enterview */
/* Load video on enter */

const llVideos = document.querySelectorAll('video.lazy');

if (llVideos.length > 0) {
  enterView({
    selector: '.video-ll',
    enter: function (el) {
      el.load();
      el.play();
    },
    offset: 0.1
  });
}

// Account nav
function handleAccountPageNav() {
  const pathname = window.location.pathname;
  const hash = window.location.hash;
  const links = document.querySelectorAll('.account-nav-link');

  if (!links.length) return;

  links.forEach(link => link.classList.remove('active'));

  if (pathname === '/account') {
    const sections = document.querySelectorAll('.account-section');

    sections.forEach(section => section.classList.add('hidden'));

    const currentHash = hash || '#dashboard';
    const sectionId = currentHash.replace('#', 'account-');
    const activeSection = document.getElementById(sectionId);
    if (activeSection) {
      activeSection.classList.remove('hidden');
    }

    links.forEach(link => {
      const hrefHash = link.getAttribute('href').split('#')[1];
      if (`#${hrefHash}` === currentHash) {
        link.classList.add('active');
      }
    });

    if (!hash) {
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}#dashboard`
      );
    }
  }

  if (pathname.includes('/account/addresses')) {
    const addressLink = document.getElementById('addresses-link');
    addressLink?.classList.add('active');
  }
}

document.addEventListener('DOMContentLoaded', handleAccountPageNav);
window.addEventListener('hashchange', handleAccountPageNav);

// Header scroll
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header');
  const body = document.body;

  if (!header) return;

  const handleScroll = () => {
    if (window.scrollY > 70) {
      header.classList.add('is-scrolled');
      body.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
      body.classList.remove('is-scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll);
  handleScroll();
});

// Mailchimp submit and success message
(function () {
  function serializeForm(form) {
    const params = new URLSearchParams();
    Array.from(form.elements).forEach(el => {
      if (!el.name || el.disabled) return;
      params.append(el.name, el.value);
    });
    return params.toString();
  }

  function submitMailchimpForm(form) {
    const action = form.getAttribute('action');
    if (!action) return;

    const callbackName =
      'mcCallback_' + Math.random().toString(36).substring(2);
    const url =
      action.replace('/post?', '/post-json?') +
      '&c=' +
      callbackName +
      '&' +
      serializeForm(form);

    const script = document.createElement('script');
    script.src = url;
    document.body.appendChild(script);

    window[callbackName] = function (response) {
      delete window[callbackName];

      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }

      const successEl = form.querySelector(
        '.js-subscribe-response-success'
      );
      const errorEl = form.querySelector('.js-subscribe-response');
      const formEl = form.querySelector('.js-subscribe-form');

      if (response.result === 'success') {
        formEl?.classList.add('hidden');
        errorEl?.classList.add('hidden');
        successEl?.classList.remove('hidden');
      } else {
        errorEl.textContent = response.msg.replace(/<[^>]*>/g, '');
        errorEl?.classList.remove('hidden');
      }

      form.reset();
    };
  }

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('[data-mailchimp-form]');
    if (!form) return;

    e.preventDefault();
    submitMailchimpForm(form);
  });
})();

// Collection filter
document.addEventListener('DOMContentLoaded', () => {
  const filters = document.querySelector('.collection__filter');
  const referrer = document.referrer;

  if (
    filters &&
    referrer.includes('/collections/') &&
    window.location.pathname.includes('/collections/')
  ) {
    filters.scrollIntoView({ behavior: 'auto' });
  }
});
